import { render, staticRenderFns } from "./COA.vue?vue&type=template&id=4b95a0a9&"
import script from "./COA.vue?vue&type=script&lang=js&"
export * from "./COA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports